const IP_PROVIDERS = [
  {
    url: "https://api.ipify.org?format=json",
    parse: (body: unknown) => (body as { ip?: string }).ip ?? null,
    responseType: "json" as const,
  },
  {
    url: "https://icanhazip.com",
    parse: (body: unknown) => (typeof body === "string" ? body.trim() : null),
    responseType: "text" as const,
  },
];

export async function fetchSourceIpFromProviders(): Promise<string | null> {
  for (const provider of IP_PROVIDERS) {
    try {
      const response = await fetch(provider.url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const body =
        provider.responseType === "json"
          ? await response.json()
          : await response.text();
      const ip = provider.parse(body);
      if (ip) return ip;
    } catch (error) {
      console.warn(`Failed to fetch IP from ${provider.url}`, error);
    }
  }
  return null;
}
